import { useI18nContext } from "~/i18n/i18n-react";

import { Disclaimer } from "../slids/disclaimer";
import { Privacy } from "../slids/Privacy";
import { Terms } from "../slids/Terms";

function Footer() {
  const { LL } = useI18nContext();

  return (
    <footer className="w-full bg-white relative z-30 border-t border-gray-100 mt-auto">
      <div className="container mx-auto py-8">
        <div className="flex flex-col md:flex-row gap-8 justify-between items-center text-secondary-dark-grey">
          <img
            alt="Musahama-icon"
            className="h-16 w-auto object-contain hover:scale-105 transition-transform duration-300"
            src="/Assets/images/master/logo.svg"
          />

          <ul className="flex flex-wrap justify-center gap-6 md:gap-8 p-0 text-center text-sm font-medium text-secondary-mid-grey">
            <li className="hover:text-primary-green transition-colors cursor-pointer">
              <Terms />
            </li>
            <li className="hover:text-primary-green transition-colors cursor-pointer">
              <Privacy />
            </li>
            <li className="hover:text-primary-green transition-colors cursor-pointer">
              <Disclaimer />
            </li>
          </ul>

          <p className="text-xs text-secondary-light-grey text-center md:text-right">
            All rights reserved to Public Investment Fund © {new Date().getFullYear()}
          </p>
        </div>
      </div>
    </footer>
  );
}
export default Footer;
